import styled from 'styled-components';

export const StyledLocationHeader = styled.header`
  display: flex;
  flex-direction: column;
`;
